var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preferences"},_vm._l((_vm.preferences),function(preference){return _c('div',{key:preference.type,staticClass:"preference"},[_c('IntegrationSettingsPreferenceOption',{attrs:{"preference":preference},on:{"switched":_vm.handleSwitch,"update-preference-value":_vm.handleUpdate}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }